import React from 'react';

export default class Download extends React.Component {
  render() {
    return (
      <div className="container download">
        <h2>Download</h2>
          <p>Both raw data (FASTQ files) as well as processed data (count matrices) can be downloaded from the Gene Expression Omnibus.</p>
            <h3>22 nuclei dataset</h3>
            <p>GEO: <a href="https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=GSE133911">GSE133911</a></p>
              <h3>single-cell dataset</h3>
              <p>GEO: <a href="https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=GSE133912">GSE133912</a></p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Download.jsx